import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    fontSize: theme.size.sm,
    padding: '0.25rem 0.5rem',

    '& > :not(:last-child)': {
      marginRight: '0.5rem'
    }
  },

  create: {
    marginTop: '0.5rem',
    width: 'auto',
    minWidth: 'calc(64px + 2rem) !important',
    height: '54px',
    paddingInline: '1rem'
  },

  icon: {
    flexShrink: '0'
  }
}))

export default useStyles
